import InvoiceContainer from "./InvoiceContainer";
import InvoiceStore from "./InvoiceStore";

export default InvoiceStore(InvoiceContainer);